import classnames from "classnames";
import * as React from "react";

import "./styles.less";

export type ImageCoverMode = "contain" | "cover";

export type ImageProps = React.HTMLProps<HTMLDivElement> & {
  coverMode?: ImageCoverMode;
  src: string;
};

const Image = ({ className, coverMode, src, ...props }: ImageProps) => (
  <div className={classnames("image", className, coverMode)} {...props}>
    {src.indexOf(".svg") >= 0 ? (
      <svg>
        <use href={src} />
      </svg>
    ) : (
      <img src={src} />
    )}
  </div>
);

export default React.memo(Image);
